import React, { ReactNode } from 'react';
import Modal from './Modal';

interface DialogModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  size?: "md" | "lg" | "xl" | "2xl" | "4xl";
  children: ReactNode;
  footer?: ReactNode;
  primaryAction?: {
    label: string;
    onClick: () => void;
    icon?: ReactNode;
    disabled?: boolean;
    className?: string; // Optional override for primary button style
    type?: "button" | "submit" | "reset";
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
  };
}

const DialogModal: React.FC<DialogModalProps> = ({
  isOpen,
  onClose,
  title,
  size = "md",
  children,
  footer,
  primaryAction,
  secondaryAction
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size={size} position="top-center">
      <div className="flex flex-col h-full">
        <div className="flex-grow overflow-y-auto">
            {children}
        </div>
        
        {(footer || primaryAction || secondaryAction) && (
          <div className="mt-6 pt-4 border-t border-slate-700 flex gap-3">
            {footer ? footer : (
              <>
                {primaryAction && (
                  <button
                    type={primaryAction.type || "button"}
                    onClick={primaryAction.onClick}
                    disabled={primaryAction.disabled}
                    className={`flex-1 flex items-center justify-center gap-2 py-2 px-4 rounded-lg font-semibold text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${primaryAction.className || 'bg-green-600 hover:bg-green-700'}`}
                  >
                    {primaryAction.icon}
                    {primaryAction.label}
                  </button>
                )}
                {secondaryAction && (
                   <button
                    type="button"
                    onClick={secondaryAction.onClick}
                    disabled={secondaryAction.disabled}
                    className="flex-1 bg-slate-700 hover:bg-slate-600 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
                   >
                     {secondaryAction.label}
                   </button>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DialogModal;
